// extracted by mini-css-extract-plugin
module.exports = {"labelWrapper":"SendPaymentModal_labelWrapper__kqFmO","label":"SendPaymentModal_label__1Fv9h","deleteButton":"SendPaymentModal_deleteButton__1zZ9C"};